interface TenantFooterCounts {
  tenantsLeaseExpiring?: number | null;
  tenantsMovingOut?: number | null;
  tenantsMovingIn?: number | null;
}

// The backend only emits "<Name>Raw" formatted entries for properties tagged [FormatInt] /
// [FormatDecimal], which these three counts are not -- reading formatted.<Name>Raw always gave
// undefined, so the hover tooltip showed a bogus "0". They are plain, never-abbreviated integers,
// so value and valueRaw are the same number; DashboardCard then suppresses the tooltip entirely
// (it only shows one when the displayed value differs from the raw one).
export const buildTenantFooterColumns = (counts?: TenantFooterCounts | null) => {
  const leaseExpiring = counts?.tenantsLeaseExpiring || 0;
  const movingOut = counts?.tenantsMovingOut || 0;
  const prospect = counts?.tenantsMovingIn || 0;

  return [
    { value: leaseExpiring, label: "Lease Expiring", valueRaw: leaseExpiring },
    { value: movingOut, label: "Moving Out", valueRaw: movingOut },
    { value: prospect, label: "Prospect", valueRaw: prospect },
  ];
};
